import classNames from 'classnames';
import React, { FC, useState } from 'react';

import { Chip } from '@sbu/components.chip';

import { ResizeContainer } from 'shared/components/utils/ResizeContainer';

import { FIELDS_PREFIX } from '../FavoriteFields';
import { RecordType, RecordValue } from '../Records';
import css from './FavoriteFieldChip.module.scss';

interface FavoriteFieldChipProps {
  prefix: string;
  name: string;
  record: RecordType;
}

export const FavoriteFieldChip: FC<
  React.PropsWithChildren<FavoriteFieldChipProps>
> = ({ prefix, name, record }) => {
  const [isOverflow, setIsOverflow] = useState<boolean>(false);

  // Account for nested fields.
  const recordValue = name.startsWith(FIELDS_PREFIX)
    ? record.fields[name.slice(FIELDS_PREFIX.length)]
    : record[name];

  return (
    <Chip
      className={css.chip}
      prefix={prefix}
      label={
        <ResizeContainer onSize={({ width }) => setIsOverflow(width >= 250)}>
          <div className={classNames(css.value, { [css.fade]: isOverflow })}>
            <RecordValue
              hideDots={true}
              name={name}
              record={record}
              showTooltipWithValue={isOverflow}
            >
              {recordValue}
            </RecordValue>
          </div>
        </ResizeContainer>
      }
      title={`${prefix}: ${recordValue}`}
    />
  );
};
